<template>
  <div>

    <v-form ref="inputForm" @submit.prevent="">
      <v-container px-10 fill-height ms-auto class="containerMaxWidth"> 

        <div v-if="isMember">
          <v-stepper non-linear>
            <div class="c-stepper__header">
              <div tabindex="-1" class="c-stepper__step">
                <span class="c-stepper__step__step primary"><v-icon  icon="icon" color="white">mdi-account-reactivate</v-icon></span>
                <div class="c-stepper__label"> {{ $let('ConfirmMembership_SectionTitle') }} </div>
              </div>
            </div>
          </v-stepper>
        </div>

        <div v-if="!isMember">
          <v-stepper non-linear>
            <div class="c-stepper__header">
              <div tabindex="-1" class="c-stepper__step">
                <span class="c-stepper__step__step primary">
                  <v-icon  icon="icon" color="white">mdi-map-marker-check</v-icon>
                </span>
                <div class="c-stepper__label"> {{ $let('CommonBond_SectionTitle') }} </div>
              </div>
            </div>
          </v-stepper>
        </div>
        
        <!-- Member Validate Membership -->
        <v-row v-if="isMember" no-gutters>
          <v-col>
            <v-sheet  color="white" class="pa-10 custom-shadow">
            
              <div v-html="$let('ConfirmMembership_SectionSubTitle')" class="subtitle-enquiry transition-swing mb-5"></div>
              
              <v-row class="col6__px" no-gutters>

                  <v-col cols="12" sm="12" md="6">
                    <TextField 
                      v-model="model.memberNumber"
                      :maxlength="10"
                      :label="$let('ConfirmMembership_MemberNumberEntry')"
                      :rules="[!!model.nin || rules.required, rules.text]">
                    </TextField>

                    {{ $let('Or') }}

                    <TextField 
                      v-model="model.nin"
                      :label="$let('ConfirmMembership_PPSOrNINumberEntry')"
                      :rules="[!!model.memberNumber || rules.required, rules.nin]">
                    </TextField>
                  </v-col>
            
                  <v-col cols="12" sm="12" md="6">
                  </v-col>

              </v-row>

              <StepperButtons
                @continueClick="_continueButtonClick"
                @backClick="_backButtonClick" >
              </StepperButtons>

            </v-sheet>
          </v-col>  
        </v-row>

        <!-- Non Member CommonBond -->
        <v-row v-if="!isMember" class="col6__px" no-gutters>
          <v-col>
            <v-sheet color="white" class="custom-shadow pa-10">  
          
              <v-row no-gutters>
                <v-col>
                  <div v-html="commonBondStatement"></div>
                
                  <v-radio-group column
                    @change="_mnmSelection"
                    v-model="model.commonBond"
                    :rules="[model.commonBond != undefined || rules.required]">

                    <v-radio :label="$let('CommonBond_LiveInArea')" value="LiveInArea"></v-radio>
                    <v-radio :label="$let('CommonBond_WorkInArea')" value="WorkInArea"></v-radio>
                    <v-radio :label="$let('CommonBond_OutsideArea')" value="OutsideArea"></v-radio>
                  
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row v-if="model.commonBond === 'LiveInArea' || model.commonBond === 'WorkInArea' && postcodeCheckEnabled">

                <v-col cols="12" md="6" sm="12">
                  
                  <div v-html="$let('CommonBond_PostCodeTitle')" class="mb-5"></div>

                  <TextField 
                    v-model="model.commonBondPostCode"
                    :label="$let('CommonBond_PostCodeEntry')"
                    :rules="[rules.required, rules.postCode]"
                    @confirm="_postCodeSearch"
                    @clear="_resetPostCode"
                    @change="_postCodeSearch"
                    @blur="_postCodeSearch"
                    @keypress.enter="_postCodeSearch"
                    :appendIcons="postCodeIcons">
                  </TextField>
                
                </v-col>

                <v-col cols="12" md="6" sm="12">
                </v-col>
              </v-row>

              <!-- Valid Common Bond -->
              <v-row v-if="model.validCommonBond === true" no-gutters>
                <v-col cols="12" md="12" sm="12">
                  <v-banner two-line tile elevation="0" color="SuccessBanner">
                    <v-avatar slot="icon" size="40">
                      <v-icon  icon="icon" color="SuccessBanner-darken-1">mdi-check</v-icon>
                    </v-avatar>
                    <v-sheet color="SuccessBanner SuccessBanner-darken-1--text" v-html="$let('CommonBond_PostCodeResultAllowed')"></v-sheet >
                  </v-banner>
                </v-col>
              </v-row>

              <!-- Invalid Common Bond -->
              <v-row v-if="model.commonBond === 'OutsideArea' || model.validCommonBond === false" no-gutters>
                
                <!-- Allow anyway -->
                <v-row v-if="allowOutsideArea" no-gutters>
                  <v-col cols="12" md="12" sm="12">
                    <v-banner two-line tile elevation="0" color="SuccessBanner">
                      <v-avatar slot="icon" size="40">
                        <v-icon  icon="icon" color="SuccessBanner-darken-1">mdi-check</v-icon>
                      </v-avatar>
                      <v-sheet color="SuccessBanner SuccessBanner-darken-1--text" v-html="$let('CommonBond_PostCodeResultOutsideAllowed')"></v-sheet >
                    </v-banner>
                  </v-col>
                </v-row>

                <!-- Not allowed -->
                <v-row  v-if="!allowOutsideArea" no-gutters>
                  <v-col cols="12" md="12" sm="12" >
                    <v-banner two-line tile elevation="0" color="ErrorBanner">
                      <v-avatar slot="icon" size="40">
                        <v-icon  icon="icon" color="ErrorBanner-darken-1">mdi-close</v-icon>
                      </v-avatar>
                      <v-sheet color="ErrorBanner ErrorBanner-darken-1--text" v-html="$let('CommonBond_PostCodeResultOutsideNotAllowed')"></v-sheet >
                    </v-banner>
                  </v-col>
                </v-row>

              </v-row>

              <StepperButtons
                :continueEnabled="continueEnabled"
                @continueClick="_continueButtonClick"
                @backClick="_backButtonClick" >
              </StepperButtons>

            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    
  </div>
</template>

<script>

  import { mapState, mapActions, mapGetters } from "vuex";
  import StepperButtons from '../components/stepper-buttons.vue'
  import TextField from '@/shared/components/text-field.vue'
  import generic from '@/shared/utils/generic.js';
  import paramKeys from '../constants/param-keys.js'
  import validators from '@/shared/utils/validators.js';
  import router from '../router';
  import routerNames from '../router/router-names';

  export default {
    name: 'ConfirmMembership',
    components: {
      TextField,
      StepperButtons
    },
    data() {
      return {
        allowOutsideArea: false,
        commonBondStatement: '',
        rules: validators.validationRules({ reqFld: this.$let('RequiredFieldEmptyMessage'), 
                                            invNIN: this.$let('InvalidNINumber'), 
                                            invPostCode: this.$let('InvalidPostCode')}),
        continueEnabled: false,
        canLogin: undefined,
        postCodeIcons: [{icon: 'mdi-crosshairs', event: 'confirm'}],
        postcodeCheckEnabled: undefined,
        model: {
          commonBond: undefined,
          validCommonBond: undefined,
          memberNumber: undefined,
          nin: undefined,
          commonBondPostCode: undefined,
        }, 
      };
    },
    created() {
      // Set allowed areas texts
      let allowedAreas = '';
      this.referenceData()?.MemberAreas.forEach(el => { 
        allowedAreas += "<li>".concat(el.Value, "</li>");
      });
      this.commonBondStatement = this.$let('CommonBond_Statement').replaceAll("{CommonBondAllowedAreas}", allowedAreas);

      // Check for "Allow Applyants From Outside CommonBond"
      this.allowOutsideArea = generic.paramValue(this.$store, paramKeys.AllowFromOutsideCommonBond).toBool();
    },
    mounted() {
      if (!this.$store.state.loanEnquiryData.eligible) router.push({ name: routerNames.Home});
      else {
        this.model.commonBond = this.$store.state.loanEnquiryData.commonBond;      
        this.model.validCommonBond = this.$store.state.loanEnquiryData.validCommonBond;
        this.model.memberNumber = this.$store.state.loanEnquiryData.memberNumber;
        this.model.nin = this.$store.state.loanEnquiryData.nin;
        this.model.commonBondPostCode = this.$store.state.loanEnquiryData.commonBondPostCode;
        
        const hidePostcodeCheck = generic.paramValue(this.$store, paramKeys.HidePostcodeCheck).toBool();
        this.postcodeCheckEnabled = !hidePostcodeCheck;

        this.continueEnabled = this.$store.state.loanEnquiryData.validCommonBond || this.allowOutsideArea;
      }
    },    
    methods: {
      ...mapGetters(["referenceData"]),
      ...mapActions(["updateLocalLoanEnquiryData"]),

      _continueButtonClick() {
        if (this.$refs.inputForm.validate()) {
          this.updateLocalLoanEnquiryData(this.model);
          
          const paymentStepEnabled = !this.isMember && generic.paramValue(this.$store, paramKeys.PaymentStepEnabled).toBool();
          
          const nextStep = paymentStepEnabled
            ? routerNames.Payment
            : routerNames.ValidateMobile;
          
          router.push({ name: nextStep });
        }
      },

      _backButtonClick() { 
        router.push({ name: routerNames.MemberNonMember });
      },

      _mnmSelection(selection) {

        const hidePostcodeCheck = generic.paramValue(this.$store, paramKeys.HidePostcodeCheck).toBool();
        this.postcodeCheckEnabled = !hidePostcodeCheck;

        this._resetPostCode();
        // Continue if: 'OutsideArea' AND AllowOutsideArea, OR CommonBond WAS SET AND IS VALID OR CommonBond WAS SET IS NOT VALID but AllowOutsideArea
        this.continueEnabled = (selection === 'OutsideArea' && this.allowOutsideArea)
          || (selection === 'WorkInArea' && !this.postcodeCheckEnabled) 
          || (this.model.validCommonBond !== undefined && (!this.model.validCommonBond && !this.allowOutsideArea));
      },

      _postCodeSearch() {
        
        if (this.$refs.inputForm.validate()) {
          const cbPc = this.model.commonBondPostCode.replaceAll(" ", ""); // Strip spaces from inserted value
          for (let idx = 0; idx < cbPc.length; idx++) {
            const toValidate = cbPc.substring(0, idx + 1);
            if (toValidate.length >= 2) { // Minimum length to validate
              const postCode = this.referenceData().CommonBondPostCodes.filter(el => el.Value.toLowerCase().replaceAll(" ", "") === toValidate.toLowerCase());
              
              this.model.validCommonBond = postCode.length > 0
              if (this.model.validCommonBond) break;
            }
          }
          this.continueEnabled = this.model.validCommonBond || this.allowOutsideArea;
          this.updateLocalLoanEnquiryData(this.model);
        }
      }, 

      _resetPostCode() {
        // Reset previous selections
        this.model.postCode = undefined;
        this.model.validCommonBond = undefined;
        this.model.commonBondPostCode = undefined;
        
      }
    },
    computed: {
      ...mapState({
        isMember: (state) => state.loanEnquiryData.isMember,
      }),
    },
  };
</script>

<style lang="scss" scoped>

</style>